/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { Injectable } from '@angular/core';

/**
 * Provides the DataPointsApiConfiguration configuration object with a given root URL.
 */
export function provideDataPointsApiConfiguration(rootUrl: string) {
  var config = new DataPointsApiConfiguration();
  config.rootUrl = rootUrl;
  return {
    provide: DataPointsApiConfiguration,
    useValue: config
  };
}

/**
 * Global configuration
 */
@Injectable({
  providedIn: 'root',
})
export class DataPointsApiConfiguration {
  rootUrl: string = '';
}

